import { PropsWithChildren } from "react";

import AppTooltip from "../tooltip";

interface IConditionalTooltipProps {
  condition: boolean;
  value: string;
}

export const ConditionalTooltip = ({
  condition,
  value,
  children,
}: PropsWithChildren<IConditionalTooltipProps>) => {
  return condition ? (
    <AppTooltip content={value}>{children}</AppTooltip>
  ) : (
    children
  );
};
